import {LinkTarget} from "./link-target";
import type {KnowledgeObjectType} from "../knowledge-object-type.type";

/** A Linkview tile linking to a `KnowledgeObject` (Anke, 2026-09-04). Generic
 *  across all `KnowledgeObjectType`s on purpose (Anke: rather generic now than a
 *  parallel class later) — this feature only ever constructs one with
 *  `knowledgeObjectType: 'whiteboard'` (via the picker in
 *  `ha-dialog-link-tile-edit`) and only `ha-dialog-whiteboard-view`/the
 *  `link-tile-knowledge-object` tile's click handler actually know how to open
 *  one — both explicitly gate on `knowledgeObjectType === 'whiteboard'`.
 *  Supporting `document`/`image` later is an extension of THOSE two call sites,
 *  not another change to this class. */
export class KnowledgeObjectLinkTarget extends LinkTarget {

    public readonly kind = 'knowledge-object' as const;

    public constructor(
        public readonly uid: string,
        public readonly knowledgeObjectType: KnowledgeObjectType,
    ) {
        super();
    }

    public toJSON(): Record<string, unknown> {
        return {kind: this.kind, uid: this.uid, knowledgeObjectType: this.knowledgeObjectType};
    }

}
